import styled from 'styled-components';
import { Icon } from '../../stories/atoms';
import { ColumnFlexContainer } from '../../stories/atoms/containerV2/ContainerV2';
import { IconWithText } from '../../stories/molecules';
import { getSpacing, Spacing } from '../../utils';

export const FlexRow = styled.div`
  display: flex;
`;

export const FlexColumn = styled(FlexRow)`
  flex-direction: column;
`;

export const StyledButton = styled(IconWithText)<{ hasRadius?: boolean; margin?: Spacing }>`
  background-color: ${({ theme: { palette, color } }) => (palette.mode === 'dark' ? color.white : color.primary)};
  border-radius: ${({ theme: { spacing }, hasRadius }) => hasRadius && spacing(4)};
  margin: ${({ theme: { spacing }, margin }) => margin && getSpacing(margin, spacing)};
  height: ${({ theme: { spacing } }) => spacing(10)};
  & > div {
    color: ${({ theme: { palette, color } }) => (palette.mode === 'dark' ? color.primary : color.white)};
  }
`;

export const StyledNote = styled(FlexRow)`
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundWarning : color.backgroundWarning};
  border-radius: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1, 2)};
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  & > * {
    color: ${({ theme: { color, palette } }) =>
      palette.mode === 'dark' ? color.warningLight : color.warningDark};
  }
`;

export const StyledPickContainer = styled(ColumnFlexContainer)`
  & > :last-child {
    border: none;
  }
`;

export const StyledIcon = styled(Icon)<{ sizeSpacing?: Spacing }>`
  width: ${({ theme: { spacing }, sizeSpacing }) => sizeSpacing && getSpacing(sizeSpacing, spacing)};
  height: ${({ theme: { spacing }, sizeSpacing }) => sizeSpacing && getSpacing(sizeSpacing, spacing)};
`;
